export const PERMISSION_CREATE_GAME_WITHOUT_PARTICIPATING = 'createGameWithoutParticipating'
export const PERMISSION_TO_ADD_FRIENDS_DIRECTLY = 'addFriendsDirectly'
export const PERMISSION_TO_CREATE_GAME_WITH_RESTRICTED_PLAYERS = 'createGameMaxPlayerCount'
export const PERMISSION_TO_CREATEGAME_FOR_PREMIUM_ONLY = 'createGamePremiumOnly'
export const PERMISSION_TO_CREATE_OFFICIAL_COMPETITION = 'createOfficialCompetition'
export const PERMISSION_TO_CREATE_PUBLIC_COMPETITION = 'createPublicCompetition'
export const PERMISSION_TO_FORCE_ADVERTISING = 'forceAdvertising'
export const PERMISSION_TO_CREATEGAME_WITH_CHECKIN = 'createGameWithCheckin'
export const PERMISSION_TO_SET_START_DATE = 'createCompetitionWithStartDate'
export const PERMISSION_TO_CREATE_GAME_WITH_MANUAL_ROUND = 'createGameWithManualNextRound'
export const PERMISSION_TO_CREATE_KO_GAME_WITH_THIRD_PLACE = 'createKOGameWithThirdPlace'
export const PERMISSION_TO_CREATE_PUBLIC_USERCUP = 'createPublicUserCup'

export default {
  methods: {
    envGetGlobalKey(key) {
      if (this.$store.state.env.global) {
        let ret = this.$store.state.env.global[key];
        return ret;
      }
      return undefined
    },
    envGetUserKey(key) {
      if (this.$store.state.env && this.$store.state.env.user) {
        let ret = this.$store.state.env.user[key];
       //  console.log('Returning ', ret, ' for user key ', key )
        return ret;
      }
      return undefined;
    },
    hasPermission: function(key) {
      let userKey = 'permission.' + key
      let val = this.envGetUserKey(userKey);
      return (val === true);
    },

    hasPermissionToCreateGameWithoutParticipating() {
      return this.hasPermission(PERMISSION_CREATE_GAME_WITHOUT_PARTICIPATING);
    },
    hasPermissionToAddFriendsDirectly() {
      return this.hasPermission(PERMISSION_TO_ADD_FRIENDS_DIRECTLY);
    },
    hasPermissionToCreateGameForPremiumAccountsOnly() {
      return this.hasPermission(PERMISSION_TO_CREATEGAME_FOR_PREMIUM_ONLY)
    },
    hasPermissionToSetCompetitionStartDate() {
      return this.hasPermission(PERMISSION_TO_SET_START_DATE)
    },
    hasPermissionToCreateGameWithCheckin() {
      return this.hasPermission(PERMISSION_TO_CREATEGAME_WITH_CHECKIN)
    },
    hasPermissionToCreateGameWithRestrictedPlayerCount() {
      return this.hasPermission(PERMISSION_TO_CREATE_GAME_WITH_RESTRICTED_PLAYERS)
    },
    hasPermissionToCreateOfficialCompetition() {
      return this.hasPermission(PERMISSION_TO_CREATE_OFFICIAL_COMPETITION)
    },
    hasPermissionToCreatePublicCompetition() {
      return this.hasPermission(PERMISSION_TO_CREATE_PUBLIC_COMPETITION)
    },
    hasPermissionToCreatePublicUserCup() {
      return this.hasPermission(PERMISSION_TO_CREATE_PUBLIC_USERCUP)
    },
    hasPermissionToCreateGameWithManualNextRound() {
      return this.hasPermission(PERMISSION_TO_CREATE_GAME_WITH_MANUAL_ROUND)
    },
    hasPermissionToCreateKOGameWithThirdPlace() {
      return this.hasPermission(PERMISSION_TO_CREATE_KO_GAME_WITH_THIRD_PLACE)
    },
    hasPermissionToCreateKOGameWithRandomMatchOpponents() {
      return this.hasPermissionToCreateKOGameWithThirdPlace()
    },
    hasPermissionToCreateLeagueOneRound() {
      return this.hasPermissionToCreateKOGameWithThirdPlace()
    },
    hasPermissionToForceAdvertising() {
      return this.hasPermission(PERMISSION_TO_FORCE_ADVERTISING)
    },
    hasPermissionToHideCoins() {
      return this.coinsEnabled();
    },
    hasPermissionToLinkExtAccountDriver(driver)
    {
      let drivers = this.envGetUserKey('permission.linkExtAccountDrivers')
      return drivers && drivers.find((d) => {return driver == d})
    },
    coinsEnabled() {
      return this.envGetUserKey('coins.enabled') == true;
    },
    /**
     * Warn: DO NOT TRUST this flag. It could be set by the user in the browser.
     */
    isSuperUser() {
      return this.envGetUserKey('isSuperUser') == true;
    },
    isOrganisator() {
      return this.envGetUserKey('isOrganisator') == true;
    },
    isPremiumFeatureEnabled() {
      return this.envGetGlobalKey('premiumFeature') == true;
    },
    isSupportAssociationFeatureEnabled() {
      return this.$tenant.tenant == 'default'
    }
  }
}
